import { jsx as t } from "react/jsx-runtime";
import { useMemo as e } from "react";
const p = ({ children: r, className: s, ...o }) => e(() => typeof r == "string" && (r != null || /^[\s]*$/.test(r)), [r]) ? /* @__PURE__ */ t(
  "p",
  {
    className: `input-field-error-msg ${s ?? ""}`,
    ...o,
    children: r
  }
) : null;
export {
  p as default
};
